import { render, staticRenderFns } from "./headerC.vue?vue&type=template&id=8af06a5e&scoped=true&"
import script from "./headerC.vue?vue&type=script&lang=js&"
export * from "./headerC.vue?vue&type=script&lang=js&"
import style0 from "./headerC.vue?vue&type=style&index=0&id=8af06a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af06a5e",
  null
  
)

export default component.exports